export enum WorkType {
    Technical,
    Additional,
    Certification,
}
